module.exports = __webpack_public_path__ + "img/2025-11-17c_14.84fe5698.jpg";